import { format } from 'date-fns';
import { de } from 'date-fns/locale';

export const formatGermanDate = (date: Date | string, formatString: string = 'dd. MMMM yyyy'): string => {
  const dateObj = typeof date === 'string' ? new Date(date) : date;
  return format(dateObj, formatString, { locale: de });
};
